import React from 'react';

export default function InputRadioCollection(props) {
  const {
    className,
    headingText,
    radioOptions,
  } = props;

  return (
  <div className={`input-radio-collection ${ className || ''}`}>
    {headingText &&
    <h3 className="input-checkbox-collection__heading fw600 c-black mb8 ff-gr fz16 lh1.5">
    { headingText }
    </h3>
    }
    <div className="input-radio-collection__option-container">
    {
      radioOptions.map(({ labelText, value, id }, i) => (
      <div
        key={i}
        className="df aic mb8"
      >
        <input
          className="input-radio-collection__input dn"
          type="radio"
          id={id}
          name={props.name}
          value={value}
          checked={value === props.value}
          autoComplete={props.disableAutoComplete ? 'off' : 'on'}
          onChange={e => props.setValue({ [`${props.name}`] : value })}
          onBlur={e => props.setDirty({ [`${props.name}Dirty`] : true })}
        />
        <span
          role="radio"
          tabIndex="0"
          aria-checked={value === props.value}
          className="input-radio-collection__visual-checkbox mr8 bd1-s-gray round-element df jcc aic h20 w20"
          onClick={e => props.setValue({ [`${props.name}`] : value })}
          onKeyUp={e => (e.key === 'Enter' || e.key === ' ') && props.setValue({ [`${props.name}`] : value })}
        >
          <span
            className={`visual-checkbox__checkmark bgc-red round-element h10 w10 ${ value === props.value ? 'db' : 'dn' }`}
          ></span>
        </span>
        {labelText &&
        <label htmlFor={id}>{ labelText }</label>
        }
      </div>
      ))
    }
    </div>
  </div>
  )
}